<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Layout`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.3999 2.3999C4.29534 2.3999 3.3999 3.29533 3.3999 4.3999V8.6999C3.3999 9.80447 4.29533 10.6999 5.3999 10.6999H11.0499C12.1545 10.6999 13.0499 9.80447 13.0499 8.6999V4.3999C13.0499 3.29533 12.1545 2.3999 11.0499 2.3999H5.3999ZM5.3999 2.3999V4.3999H11.0499V8.6999L5.3999 8.6999V4.3999L5.3999 2.3999ZM13.9502 12.3C12.8456 12.3 11.9502 13.1955 11.9502 14.3V18.6C11.9502 19.7046 12.8456 20.6 13.9502 20.6H19.6002C20.7048 20.6 21.6002 19.7046 21.6002 18.6V14.3C21.6002 13.1955 20.7048 12.3 19.6002 12.3H13.9502ZM13.9502 14.3H19.6002V18.6L13.9502 18.6V14.3ZM16.6499 4.3999V8.6999L19.5999 8.6999L19.5999 4.3999L16.6499 4.3999ZM14.6499 4.3999C14.6499 3.29533 15.5453 2.3999 16.6499 2.3999H19.5999C20.7045 2.3999 21.5999 3.29533 21.5999 4.3999V8.6999C21.5999 9.80447 20.7045 10.6999 19.5999 10.6999H16.6499C15.5453 10.6999 14.6499 9.80447 14.6499 8.6999V4.3999ZM5.3999 18.6V14.3H8.3499L8.3499 18.6L5.3999 18.6ZM5.3999 12.3C4.29533 12.3 3.3999 13.1955 3.3999 14.3V18.6C3.3999 19.7046 4.29533 20.6 5.3999 20.6H8.3499C9.45447 20.6 10.3499 19.7046 10.3499 18.6V14.3C10.3499 13.1955 9.45447 12.3 8.3499 12.3H5.3999Z"/></svg>
</template>
<script>

export default {
  name: 'IconLayout',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
